<template>
    <form class="verification-code">
        <header>
            <label>Enter code</label>
            <span v-if="countdown === 0" @click="$emit('resend')">Resend</span>
            <span v-else>{{ countdown }}s</span>
        </header>
        <div class="list">
            <input
                v-for="(n, index) in code"
                :key="index"
                type="number"
                pattern="\d*"
                :id="'input_' + index"
                maxlength="1"
                v-model="code[index]"
                :autofocus="index === 0"

                @input="handleInput"
                @keypress="isNumber"
                @keydown.delete="handleDelete"
                @paste="onPaste"
                placeholder="-"
            />
        </div>
        <p class="error-msg" v-if="error_msg" v-html="error_msg"></p>
    </form>
</template>

<script>
export default {
    name: 'verification-code',

    data() {
        return {
            code: Array(6),
            keys_allowed: ['1','2','3','4','5','6','7','8','9','0'],
            data_from_paste: '',
        }
    },

    props: {
        error_msg: {
            type: String,
            default: '',
        },
        countdown: {
            type: Number,
            default: 0,
        },
    },

    methods: {
        handleInput(event) {
            const inputType = event.inputType;
            let currentActiveElement = event.target;
            if (inputType === 'insertText') (currentActiveElement.nextElementSibling)?.focus();
            if (inputType === 'insertFromPaste' && this.data_from_paste) {
                for (const num of this.data_from_paste) {
                    let id = parseInt(currentActiveElement.id.split('_')[1]);
                    // console.log(currentActiveElement.value , num)
                    currentActiveElement.value = num;
                    this.code[id] = num;
                    
                    if (currentActiveElement.nextElementSibling) {
                        currentActiveElement = currentActiveElement.nextElementSibling;
                        (currentActiveElement.nextElementSibling)?.focus();
                    }
                }
            }

            this.code.forEach((num, index) => {
                this.code[index] = num.toString();
                // console.log(num)
            });


            this.$emit('update', this.code);
        },

        handleDelete(event) {
            let value = (event.target).value;
            let currentActiveElement = event.target;
            if (!value) (currentActiveElement.previousElementSibling)?.focus();
        },

        isNumber(event) {
            event.currentTarget.value = '';
            if (!this.keys_allowed.includes(event.key)) {
                event.preventDefault();
            }
        },

        onPaste(event) {
            this.data_from_paste = event.clipboardData
                ?.getData('text')
                .trim()
                .split('');
                

            if (this.data_from_paste) {
                for (const num of this.data_from_paste) {
                    if (!this.keys_allowed.includes(num)) event.preventDefault();
                }
            }
        },
    },

}
</script>

<style lang="scss">
    .verification-code {
        header {
            font-size: 12px;
            display: flex;
            padding: 0 4px 8px;

            label {
                color: var(--black-50);
                flex: 1;

                &::after {
                    content: ' *';
                    color: var(--alert);
                }
            }

            span {
                color: var(--blue);
                cursor: pointer;
            }
        }

        .list {
            display: flex;

            input {
                width: 54px;
                height: 54px;
                border: 1px solid var(--black-20);
                background-color: white;
                border-radius: 6px;
                color: var(--black-90);
                transition: .15s border-color ease;
                font-weight: 500;
                font-family: var(--font);
                text-align: center;
                font: var(--font-fg-18);
                margin:  0 4px;
                -moz-appearance: textfield;

                &::-webkit-inner-spin-button,
                &::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                &:hover {
                    border-color: var(--black-50);
                }
                
                &:focus {
                    outline: none;
                    border-color: var(--dark-blue);

                    &::placeholder {
                        color: transparent;
                    }
                }

                &::placeholder {
                    color: var(--black-50);
                    font-weight: 500;
                }
            }
        }

        .error-msg {
            margin: 4px;
            font-size: 12px;
            color: var(--alert);

            &::before {
                content: '*';
            }
        }

        &.success .list input {
            border-color: var(--green);
        }

        &.error .list input {
            border-color: var(--alert);
        }
    }
</style>